<h2 i18n class="title-vertical-center title-white title-large" *ngIf="errorCode">Error: {{ errorCode | errorCode }}</h2>
